var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEvaluate = function SvgEvaluate(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50A7E2"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F64C4C"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M503.557,60.05v261.381c-7.555,28.693-19.978,55.411-36.321,79.224H44.763 c-14.733-21.462-26.269-45.286-33.938-70.781V60.05c0-17,13.782-30.793,30.783-30.793h431.167 C489.775,29.257,503.557,43.05,503.557,60.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M503.557,298.297v23.134c-7.555,28.693-19.978,55.411-36.321,79.224H44.763 c-14.733-21.462-26.269-45.286-33.938-70.781v-31.577H503.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M490.854,60.488v275.299c0,10.041-6.604,18.192-14.743,18.192H38.278 c-8.15,0-14.744-8.15-14.744-18.192V60.488c0-10.052,6.593-18.192,14.744-18.192h437.833 C484.251,42.296,490.854,50.436,490.854,60.488z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.413,
    y: 400.656,
    style: {
      fill: "#666666"
    },
    width: 193.557,
    height: 75.797
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.413,
    y: 400.656,
    style: {
      fill: "#535454"
    },
    width: 193.557,
    height: 20.27
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M398.764,468.522c-5.413,3.647-10.982,7.095-16.687,10.324H129.923 c-5.13-2.905-10.156-5.987-15.057-9.226c10.136-15.287,27.376-24.785,46.174-24.785h192.303c11.16,0,21.786,3.354,30.689,9.279 C389.747,457.916,394.762,462.796,398.764,468.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAEA"
    },
    d: "M490.854,60.488v21.607H23.534V60.488c0-10.052,6.593-18.192,14.744-18.192h437.833 C484.251,42.296,490.854,50.436,490.854,60.488z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F64C4C"
    },
    cx: 48.065,
    cy: 62.192,
    r: 11.494
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDD142"
    },
    cx: 80.98,
    cy: 62.192,
    r: 11.494
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50B4A3"
    },
    cx: 113.894,
    cy: 62.192,
    r: 11.494
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8AA72"
    },
    cx: 75.494,
    cy: 162.513,
    r: 10.149
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8AA72"
    },
    cx: 135.753,
    cy: 162.513,
    r: 10.149
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F64C4C"
    },
    d: "M154.648,213.228v8.19c0,5.116-3.011,9.774-7.705,11.808c-2.85,1.235-5.767,2.346-8.743,3.325 c-10.221,3.368-21.141,5.189-32.489,5.189c-11.911,0-23.357-2.008-34.01-5.702c-2.01-0.697-3.994-1.454-5.945-2.27 c-4.82-2.012-7.978-6.701-7.978-11.924v-8.616c0-3.808,2.334-7.227,5.88-8.616l26.411-10.335h32.29l26.411,10.335 C152.315,206.002,154.648,209.421,154.648,213.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6CE9F"
    },
    d: "M105.708,197.785L105.708,197.785c-16.688,0-30.215-13.528-30.215-30.215v-38.788h60.432v38.788 C135.923,184.256,122.396,197.785,105.708,197.785z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#863924"
    },
    d: "M81.876,135.338l-9.352,4.707v21.416l0,0c5.165,0,9.352-4.187,9.352-9.352V135.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#863924"
    },
    d: "M129.54,118.864h9.352v42.598l0,0c-5.165,0-9.352-4.187-9.352-9.352V118.864z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92482F"
    },
    d: "M125.145,140.046H72.524l0,0c0-16.707,13.544-30.252,30.252-30.252h52.621l0,0 C155.397,126.502,141.853,140.046,125.145,140.046z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF764E"
    },
    cx: 379.549,
    cy: 162.513,
    r: 10.149
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF764E"
    },
    cx: 439.808,
    cy: 162.513,
    r: 10.149
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50B4A3"
    },
    d: "M458.7,213.228v8.19c0,5.116-3.011,9.774-7.705,11.808c-2.85,1.235-5.767,2.346-8.743,3.325 c-10.221,3.368-21.141,5.189-32.489,5.189c-11.911,0-23.357-2.008-34.01-5.702c-2.01-0.697-3.994-1.454-5.945-2.27 c-4.82-2.012-7.978-6.701-7.978-11.924v-8.616c0-3.808,2.334-7.227,5.88-8.616l26.411-10.335h32.29l26.411,10.335 C456.366,206.002,458.7,209.421,458.7,213.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D69272"
    },
    d: "M409.76,197.785L409.76,197.785c-16.688,0-30.215-13.528-30.215-30.215v-38.788h60.432v38.788 C439.976,184.256,426.448,197.785,409.76,197.785z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M385.928,135.338l-9.352,4.707v21.416l0,0c5.165,0,9.352-4.187,9.352-9.352V135.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M433.592,118.864h9.352v42.598l0,0c-5.165,0-9.352-4.187-9.352-9.352V118.864z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5C5C"
    },
    d: "M429.197,140.046h-52.621l0,0c0-16.707,13.544-30.252,30.252-30.252h52.621l0,0 C459.449,126.502,445.905,140.046,429.197,140.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD142"
    },
    d: "M295.05,147.113v73.291c-1.411,4.514-3.143-4.204-5.166,0c-1.55,3.214-3.271-9.469-5.153-6.465 h-66.408v-66.826c0-21.191,17.177-38.364,38.368-38.364C277.877,108.749,295.05,125.923,295.05,147.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56A6D6"
    },
    d: "M305.63,213.228v8.19c0,5.116-3.011,9.774-7.705,11.808c-2.85,1.235-5.767,2.346-8.743,3.325 c-10.221,3.368-21.141,5.189-32.489,5.189c-11.911,0-23.357-2.008-34.01-5.702c-2.01-0.697-3.994-1.454-5.945-2.27 c-4.82-2.012-7.978-6.701-7.978-11.924v-8.616c0-3.808,2.334-7.227,5.88-8.616l26.411-10.335h32.29l26.411,10.335 C303.296,206.002,305.63,209.421,305.63,213.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6CE9F"
    },
    d: "M286.872,159.491v8.564c0,15.601-11.831,28.431-27.01,30.018c-1.041,0.11-2.103,0.165-3.173,0.165 c-16.671,0-30.187-13.511-30.187-30.183v-8.564c0-16.667,13.515-30.183,30.187-30.183c1.071,0,2.133,0.055,3.173,0.165 c7.071,0.737,13.409,3.914,18.17,8.675C283.49,143.611,286.872,151.16,286.872,159.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD142"
    },
    d: "M290.849,158.087c-29.341,0-47.959-16.925-47.959-16.925c0,2.996-2.438,6.596-5.7,9.538 c-4.422,3.99-10.354,6.757-13.764,5.133l-0.846-9.026l7.054-14.954l10.583-2.67l19.6-4.947l24.263,9.592L290.849,158.087z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M153.664,281.428H59.511c-3.58,0-6.482-2.902-6.482-6.482l0,0c0-3.58,2.902-6.482,6.482-6.482 h94.152c3.58,0,6.482,2.902,6.482,6.482l0,0C160.145,278.526,157.244,281.428,153.664,281.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M120.67,307.694H59.511c-3.58,0-6.482-2.902-6.482-6.482l0,0c0-3.58,2.902-6.482,6.482-6.482h61.159 c3.58,0,6.482,2.902,6.482,6.482l0,0C127.152,304.793,124.25,307.694,120.67,307.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M304.271,281.428h-94.153c-3.58,0-6.482-2.902-6.482-6.482l0,0c0-3.58,2.902-6.482,6.482-6.482 h94.152c3.58,0,6.482,2.902,6.482,6.482l0,0C310.753,278.526,307.85,281.428,304.271,281.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M271.277,307.694h-61.159c-3.58,0-6.482-2.902-6.482-6.482l0,0c0-3.58,2.902-6.482,6.482-6.482 h61.159c3.58,0,6.482,2.902,6.482,6.482l0,0C277.759,304.793,274.857,307.694,271.277,307.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M457.715,281.428h-94.152c-3.58,0-6.481-2.902-6.481-6.482l0,0c0-3.58,2.902-6.482,6.481-6.482 h94.152c3.58,0,6.482,2.902,6.482,6.482l0,0C464.197,278.526,461.295,281.428,457.715,281.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M424.722,307.694h-61.159c-3.58,0-6.482-2.902-6.482-6.482l0,0c0-3.58,2.902-6.482,6.482-6.482 h61.159c3.58,0,6.482,2.902,6.482,6.482l0,0C431.203,304.793,428.302,307.694,424.722,307.694z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvaluate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/evaluate.da2716ba.svg";
export { ForwardRef as ReactComponent };